import { clearMessages, setMessages } from '@/i18n'
import { normalizeQueryField, QueryField } from '@/utils/query'
import { MutationTree } from 'vuex'
import { FormState } from './types'

export const mutations: MutationTree<FormState> = {
  /**
   * Set the active widget to render.
   */
  setActiveWidgetId: (state, id) => state.activeWidgetId = id,
  /**
   * Load widgets.
   */
  loadForm: (state, { default: defaultWidgetId, widgets, icons = {}, messages = {}, queryFields = [] }) => {
    clearMessages()
    setMessages(messages)
    state.messages = messages
    state.icons = icons
    state.queryFields = queryFields.map((field: QueryField | string) => normalizeQueryField(field))

    state.widgets = widgets
    state.defaultWidgetId = defaultWidgetId
    state.activeWidgetId = defaultWidgetId
  },
  /**
   * Reset the field object to an empty dict.
   */
  resetState: state => {
    state.activeWidgetId = state.defaultWidgetId
  },
}
